import React from 'react';
import { Loader as LoaderIcon } from 'lucide-react';
import PropTypes from 'prop-types';
import './loader.css';

function Loader({ size = 40, fullScreen = true }) {
  return (
    <div className={fullScreen ? 'loader-overlay' : ''}>
      <LoaderIcon className="spinner" size={size} />
    </div>
  );
}

Loader.propTypes = {
  size: PropTypes.number,
  fullScreen: PropTypes.bool,
};

export default Loader;